import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
* {
margin:0;
padding:0;
outline:0;
box-sizing:border-box;

}

ul,ol{
    padding:0;
}

a {
text-decoration: none;
}
input,textarea {
border: 1px solid var(--color-hover-blue) !important;
transition:border 0.3s ease;
border-radius:0.2rem;
    transition:box-shadow 0.1s ease;
    :focus{
    border: 1px solid var(--color-hover-blue) !important;
    box-shadow: 0.2px 0.2px 2.5px var(--color-soft-blue);
}
}
button {
cursor: pointer;
border: 0;
background: none;
outline: 0 !important;
}
html, body, #root {
min-height: 100%;
width: 100%;
}


*, button, input,textarea {
border: 0;
background: none;
outline: 0 !important;
font-family: -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Ubuntu, Arial, sans-serif;
}

body{
    font:14px 'Roboto', sans-serif;
    -webkit-font-font-smoothing: antialiased !important;
    background:var(---primary);
    color:#333;
}

button.close {
    font-size: 2rem;
}

.table-responsive {
    /* max-height: 80vh; */
}

:root {
    --color-primary: #EEF0F8;
    --color-soft-green: #3dad66;
    --color-soft-red: #e83f5b;
    --color-soft-blue:#668cff;

    --color-high-green: #119957;
    --color-high-red: #f51d41;
    --color-hover-blue:#8ba6f7;

    --color-blackPurple:#150f21;
    --color-blackWhite:#d6d5d2;
    --color-text: #a8a8b3;
  /* Template´s Color */
    --sidebar:#1e1e2d;
    --sidebar-hover:#1b1b28;
    --blue: #007bff;
    --indigo: #6610f2;
    --purple: #6f42c1;
    --pink: #e83e8c;
    --red: #dc3545;
    --orange: #fd7e14;
    --yellow: #ffc107;
    --green: #28a745;
    --teal: #20c997;
    --cyan: #17a2b8;
    --white: #ffffff;
    --gray: #7E8299;
    --gray-dark: #3F4254;
    --primary: #3699FF;
    --secondary: #E4E6EF;
    --success: #1BC5BD;
    --info: #8950FC;
    --warning: #FFA800;
    --danger: #F64E60;
    --light: #F3F6F9;
    --dark: #181C32;
    --white: #ffffff;

}`;

export const TOASTIFY_OPTIONS = {
	position: "top-right",
	autoClose: 3000,
	hideProgressBar: false,
	closeOnClick: true,
	pauseOnHover: true,
	draggable: false,
	style: { fontSize: 16 },
};
